import setFieldValue from "@bevco/Store/Handlers/CreateAccount/SetFieldValue";
import { CustomActions, CustomState } from "@bevco/Store/Reducers";
import { OwnProps, setRequestFormEffects } from "@bevco/Widgets/CreateAccount/FormBaseComponent";
import translate from "@insite/client-framework/Translate";
import Radio from "@insite/mobius/Radio";
import RadioGroup from "@insite/mobius/RadioGroup";
import * as React from "react";
import { connect, DispatchProp, ResolveThunks } from "react-redux";

const mapStateToProps = (state: CustomState) => ({
    useShippingAddress: state.customCreateAccountForm.fieldValues.useShippingAddress,
});

const mapDispatchToProps = {
    setFieldValue,
};

type Props = OwnProps &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps> &
    DispatchProp<CustomActions>;

const UseShippingAddress: React.FC<Props> = ({ useShippingAddress, setFieldValue: widgetSetFieldValue }) => {
    const isRequired = false;
    const [fieldErrorMessage, setFieldErrorMessage] = React.useState("");

    const validateFieldBy = () => {
        return true;
    };

    setRequestFormEffects(isRequired, useShippingAddress, "useShippingAddress", validateFieldBy);

    const fieldChangeHandler = (value: boolean) => {
        widgetSetFieldValue({ key: "useShippingAddress", value: `${value}` });
    };

    React.useEffect(() => {
        widgetSetFieldValue({ key: "useShippingAddress", value: "false" });
    }, []);

    return (
        <RadioGroup
            onChange={(e: any) => fieldChangeHandler(e.target.value)}
            value={useShippingAddress}
            error={fieldErrorMessage}
        >
            <Radio value="true">{translate("Use Shipping Address")}</Radio>
            <Radio value="false">{translate("Enter New Address")}</Radio>
        </RadioGroup>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(UseShippingAddress);
